import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { GameProvider } from "@/context/GameContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Game from "@/pages/Game";

function Guarded({ children }) {
  const { user, ready } = useAuth();
  if (!ready)
    return (
      <div className="min-h-screen flex items-center justify-center text-stone-400 font-display text-xl">
        Loading the realm…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function RedirectIfAuthed({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (user) return <Navigate to="/play" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route
            path="/login"
            element={<RedirectIfAuthed><Login /></RedirectIfAuthed>}
          />
          <Route
            path="/register"
            element={<RedirectIfAuthed><Register /></RedirectIfAuthed>}
          />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/play"
            element={
              <Guarded>
                <GameProvider>
                  <Game />
                </GameProvider>
              </Guarded>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#1c1917",
              border: "1px solid #b45309",
              color: "#fde68a",
              fontFamily: "Alegreya Sans, sans-serif",
            },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}
